$(document).on("performance-marketing:section:performance-marketing", function () {
    // check if have section#performance-marketing run swupPerformanceMarketing
    if ($("section#section-performance-marketing").length > 0) {
        // rebuild swiperGrid
        swupPerformanceMarketing();
    }
});

function swupPerformanceMarketing() {
    let swiperOption = {
        // grid
        autoplay: true,
        loopAddBlankSlides: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                // remove grid
                grid: {
                    rows: 1,
                    fill: 'column',
                },
                navigation: {
                    nextEl: '.mil-portfolio-next',
                    prevEl: '.mil-portfolio-prev',
                },
                pagination: {
                    el: '.swiper-portfolio-pagination',
                    type: 'fraction',
                },
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
                grid: {
                    rows: 30,
                    fill: 'row',
                },
                pagination: false,
                navigation: false,
            }
        }
    }

    const swiperGrid = new Swiper(".swiper-performance-marketing", swiperOption);

    let tl = gsap.timeline();

    $(".swiper-item").css({
        opacity: 1,
    })

    tl.fromTo(".swiper-performance-marketing .swiper-item-outer", {
        opacity: 0,
        transform: "translateY(100%)",
    }, {
        opacity: 1,
        transform: "translateY(0)",
        duration: 1,
        stagger: 0.1,
        ease: "ease",
    });
}

$(document).on("performance-marketing-detail:section:performance-marketing-detail", function () {
    if ($("#page-performance-marketing-detail").length > 0) {
        let tl = gsap.timeline();

        // only line center mobile skip
        if ($(window).width() >= 992) {
            tl.fromTo(".line-center", {
                '--line-height-center': '0%',
            }, {
                '--line-height-center': '100%',
                duration: 1,
            });

            tl.addLabel("line-opacity-center", ">");

            tl.fromTo(".line-center", {
                '--line-opacity-center': '1',
            }, {
                '--line-opacity-center': '0',
                duration: 0.1,
            }, 'line-opacity-center');
        }

        tl.addLabel("section-content", "<");

        tl.fromTo(".section-content", {
            transform: 'translateX(100%)',
            opacity: 1,
        }, {
            transform: 'translateX(0)',
            duration: 1,
        }, 'section-content');

        // same timeline with section-content
        tl.addLabel("section-content-1", "<");

        tl.fromTo(".section-content-1", {
            transform: 'translateX(-100%)',
            opacity: 1,
        }, {
            transform: 'translateX(0)',
            duration: 1,
        }, "section-content-1");

        tl.addLabel("section-inner-content", ">+=1");

        tl.fromTo(".section-inner-content", {
            transform: 'translateX(100%)',
        }, {
            transform: 'translateX(0)',
            duration: 1,
            ease: "ease",
        }, 'performance-content');

        tl.addLabel("section-inner-content-1", "<");

        tl.fromTo(".section-inner-content-1", {
            "--item-transform": 'translateY(100%)',
        }, {
            "--item-transform": 'translateY(0)',
            ease: "ease",
        }, 'section-inner-content-1');

        // run odometer after section-inner-content-1

        tl.add(runOdometer, "section-inner-content-1");

        // odometer
        function runOdometer() {
            $(".js-odometer").each(function () {
                let odometer = new Odometer({
                    el: $(this)[0],
                    value: 0,
                    duration: 2000,
                    delay: 1000,
                    format: '(,ddd).dd',
                });

                odometer.update($(this).data("odometer"));
            });
        }
    }
});
